const clubLocatorResources = {
    labelFitnessFacility: 'Fitness Facility',
    labelFitnessClass: 'Fitness Class',
    labelFlexInstructor: 'Flex Instructor',
    placeholderSearch: 'Search',
    nominateDescription: 'Didn’t find the club you were looking for?',
    buttonText: 'NOMINATE A CLUB',
    groupMembershipsOptionText: 'Group Memberships',
};
export default clubLocatorResources;